import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages d'authentification (publiques)
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import InvitationPage from './pages/InvitationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Pages protégées
import HomePage from './pages/HomePage';
import LivresPage from './pages/LivresPage';
import LivreDetailPage from './pages/LivreDetailPage';
import AjouterLivrePage from './pages/AjouterLivrePage';
import ModifierLivrePage from './pages/ModifierLivrePage';
import AuteursPage from './pages/AuteursPage';
import AuteurDetailPage from './pages/AuteurDetailPage';
import ModifierAuteurPage from './pages/ModifierAuteurPage';
import EditeursPage from './pages/EditeursPage';
import EditeurDetailPage from './pages/EditeurDetailPage';
import ModifierEditeurPage from './pages/ModifierEditeurPage';
import TagsPage from './pages/TagsPage';
import TagDetailPage from './pages/TagDetailPage';
import ModifierTagPage from './pages/ModifierTagPage';
import BibliotequesPage from './pages/BibliotequesPage';
import BibliothequeDetailPage from './pages/BibliothequeDetailPage';
import ModifierBibliothequePage from './pages/ModifierBibliothequePage';
import RayonnagesPage from './pages/RayonnagesPage';
import ModifierRayonnagePage from './pages/ModifierRayonnagePage';
import DoublonsAuteursPage from './pages/DoublonsAuteursPage';
import DoublonsEditeursPage from './pages/DoublonsEditeursPage';
import TenantPage from './pages/TenantPage';
import ProfilePage from './pages/ProfilePage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Layout>
        <Routes>
          {/* Routes publiques d'authentification */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/invitation/:token" element={<InvitationPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          
          {/* Routes protégées - Application principale */}
          <Route path="/" element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          } />
          <Route path="/livres" element={
            <ProtectedRoute>
              <LivresPage />
            </ProtectedRoute>
          } />
          <Route path="/livres/:id" element={
            <ProtectedRoute>
              <LivreDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/livres/ajouter" element={
            <ProtectedRoute>
              <AjouterLivrePage />
            </ProtectedRoute>
          } />
          <Route path="/livres/:id/modifier" element={
            <ProtectedRoute>
              <ModifierLivrePage />
            </ProtectedRoute>
          } />
          <Route path="/auteurs" element={
            <ProtectedRoute>
              <AuteursPage />
            </ProtectedRoute>
          } />
          <Route path="/auteurs/ajouter" element={
            <ProtectedRoute>
              <ModifierAuteurPage />
            </ProtectedRoute>
          } />
          <Route path="/auteurs/:id" element={
            <ProtectedRoute>
              <AuteurDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/auteurs/:id/modifier" element={
            <ProtectedRoute>
              <ModifierAuteurPage />
            </ProtectedRoute>
          } />
          <Route path="/auteurs/doublons" element={
            <ProtectedRoute>
              <DoublonsAuteursPage />
            </ProtectedRoute>
          } />
          <Route path="/editeurs" element={
            <ProtectedRoute>
              <EditeursPage />
            </ProtectedRoute>
          } />
          <Route path="/editeurs/doublons" element={
            <ProtectedRoute>
              <DoublonsEditeursPage />
            </ProtectedRoute>
          } />
          <Route path="/editeurs/:id" element={
            <ProtectedRoute>
              <EditeurDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/editeurs/ajouter" element={
            <ProtectedRoute>
              <ModifierEditeurPage />
            </ProtectedRoute>
          } />
          <Route path="/editeurs/:id/modifier" element={
            <ProtectedRoute>
              <ModifierEditeurPage />
            </ProtectedRoute>
          } />
          <Route path="/tags" element={
            <ProtectedRoute>
              <TagsPage />
            </ProtectedRoute>
          } />
          <Route path="/tags/ajouter" element={
            <ProtectedRoute>
              <ModifierTagPage />
            </ProtectedRoute>
          } />
          <Route path="/tags/:id" element={
            <ProtectedRoute>
              <TagDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/tags/:id/modifier" element={
            <ProtectedRoute>
              <ModifierTagPage />
            </ProtectedRoute>
          } />
          <Route path="/bibliotheques" element={
            <ProtectedRoute>
              <BibliotequesPage />
            </ProtectedRoute>
          } />
          <Route path="/bibliotheques/ajouter" element={
            <ProtectedRoute>
              <ModifierBibliothequePage />
            </ProtectedRoute>
          } />
          <Route path="/bibliotheques/:id/modifier" element={
            <ProtectedRoute>
              <ModifierBibliothequePage />
            </ProtectedRoute>
          } />
          <Route path="/bibliotheques/:id" element={
            <ProtectedRoute>
              <BibliothequeDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/rayonnages" element={
            <ProtectedRoute>
              <RayonnagesPage />
            </ProtectedRoute>
          } />
          <Route path="/rayonnages/ajouter" element={
            <ProtectedRoute>
              <ModifierRayonnagePage />
            </ProtectedRoute>
          } />
          <Route path="/rayonnages/:id/modifier" element={
            <ProtectedRoute>
              <ModifierRayonnagePage />
            </ProtectedRoute>
          } />
          {/* Routes protégées - Gestion utilisateur */}
          <Route path="/profile" element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          } />
          <Route path="/tenant" element={
            <ProtectedRoute requireAdmin={true}>
              <TenantPage />
            </ProtectedRoute>
          } />
          <Route path="/about" element={
            <ProtectedRoute>
              <AboutPage />
            </ProtectedRoute>
          } />
          
          {/* Redirection par défaut */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Box>
  );
}

export default App;
